import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_EXTERIOR_URL || "http://localhost:8889",
  headers: {
    "x-api-provider": "exterior-xpinvestimentos",
  },
});

export default api;
